import React, { useEffect, useState } from "react";
import { isEmpty, orderBy } from "lodash";
import { Card, CardBody, Container } from "reactstrap";
import useAxios from "hooks/useAxios";
import ErrorBoundary from "components/ErrorBoundary";
import SearchContainer from "./components/SearchContainer";
import FaxTable from "./components/FaxTable";
import { onExport, getUpdatedFilter } from "utils/helper";
import { useLocation } from "react-router-dom";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Patient from "pages/Patient";

const initialFilterBySearch = {
  coveredEntityName: "",
  direction: "",
};

const initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "",
  order: "",
  filters: [],
};

const Fax = (props) => {
  const { orgId } = props;
  const [showpatientdetails, setShowPatientDetails] = useState(false)
  const [patientIDNAME, setPatientIdName] = useState("")
  const [resetFlag, SetResetFlag] = useState(false);


  const [coveredEntity, setCoverdEntity] = useState()
  console.log(orgId, "orgid")
  const API = useAxios();
  const location = useLocation();
  let selectedCEId = window.selectedCoveredEntittyId.toString();
  const [resetflag, setResetflag] = useState(false)
  let selectedCoveredEntityID, selectedTenantID;
  const [state, updateState] = useState({
    searchFilter: initialFilterBySearch,
    selectedCoveredEntity: {},
    filters: initialFilters,
    faxList: [],
    records: 0,
    loading: false,
  });

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [colFilter, setColFilter] = useState([]);

  const handleUpdateEntity = (entity) => {
    setState({ selectedCoveredEntity: entity });
    setCoverdEntity(entity)
    selectedCoveredEntityID = entity.coveredEntityID;
    selectedTenantID = entity.tenantID;
  };

  const fetchAllFax = async (filters) => {
    let {
      selectedCoveredEntity: { coveredEntityID, tenantID },
    } = state;

    if (!coveredEntityID) {
      coveredEntityID = selectedCoveredEntityID;
    }
    if (!tenantID) {
      tenantID = selectedTenantID;
    }
    if (!coveredEntityID || !tenantID) return;
    setState({ loading: true });
    try {
      const { data } = await API.post(
        `/${tenantID}/fax/ALL/${coveredEntityID}`,
        filters
      );
      if (data) {
        setState({
          faxList: data.items,
          records: data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          loading: false,
          faxList: [],
          records: 0,
        });
      }
    } catch (error) {
      console.log(error);
      setState({
        loading: false,
        faxList: [],
        records: 0,
      });
    }
  };

  const onSearchFax = async (searchFilter) => {
    //const initialFilters = { ...state.filters };
    const { coveredEntityName, direction, faxstatus, providerNPI, patientID } =
      searchFilter;
    initialFilters.filters = [];
    let coveredEntity = coveredEntityName.toString();
    if (coveredEntityName && !isEmpty(coveredEntity)) {
      initialFilters.filters = getUpdatedFilter(
        "coveredEntityID",
        parseInt(coveredEntityName),
        initialFilters
      );
      if (direction) {
        initialFilters.filters = getUpdatedFilter(
          "directionID",
          parseInt(direction),
          initialFilters
        );
      }
      if (faxstatus) {
        initialFilters.filters = getUpdatedFilter(
          "faxStatusID",
          parseInt(faxstatus),
          initialFilters
        );
      }
      if (providerNPI) {
        initialFilters.filters = getUpdatedFilter(
          "referralProviderID",
          providerNPI,
          initialFilters
        );
      }
      if (patientID) {
        initialFilters.filters = getUpdatedFilter('patientID', patientID, initialFilters);
      }
      initialFilters.currentPage = 1;
      initialFilters.orderBy = 'createdDate';
      initialFilters.order = 'desc';
      setState({ filters: initialFilters });
      fetchAllFax(initialFilters);
    }
  };

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Fax/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, filters);
  };

  const handleExport2 = async () => {
    const searchFilter = { ...state.filters };
    var additionalCriteria = {};
    const datafilter = initialFilters.filters.filter((item) => {
      return (
        item.filterValue == ""
      )
    })
    if (datafilter.length > 0) {
      initialFilters.filters = getUpdatedFilter(
        "direction",
        (datafilter ? datafilter[0]?.filterValue : ""),
        initialFilters
      )
    }
    if (datafilter.length > 0) {
      initialFilters.filters = getUpdatedFilter(
        "faxstatus",
        (datafilter ? datafilter[0]?.filterValue : ""),
        initialFilters
      )
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;

    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    //filterObj.CoveredEntityIDS = coveredEntityID;
    if (colFilter && colFilter.length > 0) {
      searchFilter.filters = [...state.filters.filters, ...colFilter];
    }
    var payload = {};
    payload.tenantID = selectedCoveredEntity.tenantID;
    payload.gridCode = "fax";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(searchFilter);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  const onPageChange = (pageFilter) => {
    const searchFilter = { ...state.filters };
    const gridFilter = { ...state.filters };
    searchFilter.filters = [...state.filters.filters, ...pageFilter.filters];
    searchFilter.currentPage = pageFilter.currentPage;
    gridFilter.currentPage = pageFilter.currentPage;
    if (pageFilter.pageSize) {
      searchFilter.pageSize = pageFilter.pageSize;
      gridFilter.pageSize = pageFilter.pageSize;
    }
    if (pageFilter.orderBy) {
      searchFilter.order = pageFilter.order;
      searchFilter.orderBy = pageFilter.orderBy;
      gridFilter.order = pageFilter.order;
      gridFilter.orderBy = pageFilter.orderBy;
    }
    setState({ filters: gridFilter });
    fetchAllFax(searchFilter);
  };

  const filterSearch = (colFilters) => {
    setColFilter(colFilters);
    const searchFilter = { ...state.filters, currentPage: 1 };

    const baseFilters = state.filters.filters.filter(existingFilter => {
      return !colFilter.some(colF =>
        colF.filterName === existingFilter.filterName &&
        colF.filterType === existingFilter.filterType
      );
    });

    searchFilter.filters = [...baseFilters, ...colFilters];

    updateState(prev => ({
      ...prev,
      filters: searchFilter
    }));
    fetchAllFax(searchFilter);
  };

  const refetchAll = () => {
    const resetFilters = { ...initialFilters, pageSize: filters.pageSize, order: filters.order, orderBy: filters.orderBy };
    updateState(prev => ({
      ...prev,
      filters: resetFilters,
    }));
    setColFilter([]);
    fetchAllFax(resetFilters);
  };

  useEffect(() => {
    onSearchReset()
    setShowPatientDetails(false)

  }, [orgId])


  const onSearchReset = () => {
    setState({
      filters: initialFilters,
      faxList: [],
      searchFilter: initialFilterBySearch,
      selectedCoveredEntity: {},
      records: 0
    });
    SetResetFlag(true);
  };

  const {
    searchFilter,
    faxList,
    records,
    filters,
    loading,
    selectedCoveredEntity,
  } = state;

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };
  console.log(showpatientdetails, "patientdetails")
  return (
    <div>
      <Container fluid className="width_info">
        {showpatientdetails == false &&
          <>
            <div className={collapseSider ? "mb-0" : "mb-3"}>
              <Card className="border-0 shadow-top">
                <CardBody className="" hidden={collapseSider}>
                  <ErrorBoundary>
                    <SearchContainer
                      filterBySearch={searchFilter}
                      handleUpdateEntity={handleUpdateEntity}
                      onSearch={onSearchFax}
                      onReset={onSearchReset}
                      selectedCEId={selectedCEId}
                      orgId={orgId}
                      resetflag={resetflag}
                      setresetflag={setResetflag}
                    />
                  </ErrorBoundary>
                </CardBody>
              </Card>
            </div>
            <Card className="border-0 shadow-top">
              <CardBody className="pt-0">
                <ErrorBoundary>
                  <FaxTable
                    data={faxList}
                    totalRecords={records}
                    filters={filters}
                    loading={loading}
                    onExport={handleExport2}
                    orgId={orgId}
                    onPageChange={onPageChange}
                    onSearchColumnFilters={filterSearch}
                    refetch={refetchAll}
                    selectedCoveredEntity={selectedCoveredEntity}
                    collapseSider={collapseSider}
                    toggleSider={toggleSider}
                    showpatientdetails={showpatientdetails}
                    setShowPatientDetails={setShowPatientDetails}
                    resetFlag={resetFlag}
                    SetResetFlag={SetResetFlag}
                    patientIDNAME={patientIDNAME}
                    setPatientIdName={setPatientIdName}



                  />
                </ErrorBoundary>
              </CardBody>
            </Card>
          </>
        }
        {showpatientdetails == true &&
          <Patient orgId={orgId}
            module={module}
            coveredEntity={coveredEntity?.coveredEntityID}
            tenantID={coveredEntity?.tenantID}
            isfax={"true"}
            patientIDNAME={patientIDNAME}
            showpatientdetails={showpatientdetails}
            setShowPatientDetails={setShowPatientDetails}
            refetch={refetchAll}


          />
        }
      </Container>
    </div>
  );
};

export default Fax;
